import { app } from "@/main";
import { CoursesRest } from "@/services/rest/courses.rest";
import HandleError from "./handle-errors.util";
import { Messages } from "./messages.util";
import { ToastFactory } from "./toast-factory.util";
import { Course, Status } from "@/models/courses.model";
import { BehaviorSubject } from "rxjs";

export class CoursesGenerics {
  constructor(
    private _course = new CoursesRest(),
    private _errors = new HandleError()
  ) {}
  private courses$ = new BehaviorSubject<any>([]);
  courses = this.courses$.asObservable();
  sendToApprove(courseId: string, baseUrl: string): void {
    this._course.sendToApprove(courseId, baseUrl).subscribe({
      next: (response) => {
        this.courses$.next(response);
        app.config.globalProperties.$toast.add(
          ToastFactory.success(Messages.COURSE_SENDED)
        );
      },
    });
  }
  approve(courseId: string, data: any, baseUrl: string): void {
    this._course.approveCourse(courseId, data, baseUrl).subscribe({
      next: (response) => {
        this.courses$.next(response);
        app.config.globalProperties.$toast.add(
          ToastFactory.success(
            data.status === Status.PUBLISHED ||
              data.status === Status.NOT_LISTED
              ? Messages.COURSE_PUBLISHED
              : data.status === Status.REPROVED
              ? Messages.COURSE_REPROVED
              : ""
          )
        );
      },
    });
  }

  publishCourse(courseId: string): void {
    // this._course.publishCourse(courseId).subscribe({
    //   next: () => {
    //     app.config.globalProperties.$toast.add(
    //       ToastFactory.success(Messages.COURSE_PUBLISHED)
    //     );
    //   },
    // });
  }
}
